module.exports = __webpack_public_path__ + "fa1d10e7f87f2cda63c552426b75375a.png";